export default "__VITE_ASSET__C3uM7xwX__"